import {
  Page,
  Text,
  View,
  Document,
  Image,
  StyleSheet,
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: 'Helvetica',
    border: '2 solid #F6AF42',
  },
  header: {
    fontSize: 22,
    textAlign: 'center',
    marginBottom: 20,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#F6AF42',
  },
  sectionTitle: {
    fontSize: 16,
    marginBottom: 8,  
    fontWeight: 'bold',
    borderBottom: '1 solid #ddd',
    paddingBottom: 4,
    color: '#333',
  },

  tableContainer: {
    marginTop: 8,  
    borderWidth: 1,
    borderColor: '#ccc',
    borderStyle: 'solid',
    borderRadius: 4,
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#F6AF42',
    borderBottom: '1 solid #ccc',
    padding: 4,  
  },
  tableHeaderText: {
    fontWeight: 'bold',
    fontSize: 11,  
    flex: 1,
    color: '#fff',
    textAlign: 'center', 
  },
  tableRow: {
    flexDirection: 'row',
    borderBottom: '1 solid #eee',
    padding: 4,  
  },
  tableCell: {
    flex: 1,
    fontSize: 11, 
    color: '#333',
    textAlign: 'center', 
  },

  chartImage: {
    marginTop: 12,  
    width: '100%',
    height: 250,
    objectFit: 'contain',
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 10,
    color: '#888',
  },
});

const PDFReport = ({ reportSections, chartImages }) => {
  return (
    <Document>
      {reportSections.map((section, index) => (
        <Page key={index} size="A4" style={styles.page}>
          {/* Banner Heading */}
          {index === 0 && (
            <Text style={styles.header}>Vaisnava Marriage Report</Text>
          )}

          {/* Section Title */}
          <Text style={styles.sectionTitle}>{section.title}</Text>

          {/* Metrics as Table */}
          <View style={styles.tableContainer}>
            {/* Table Header */}
            <View style={styles.tableHeader}>
              <Text style={styles.tableHeaderText}>Label</Text>
              <Text style={styles.tableHeaderText}>Value</Text>
            </View>

            {/* Table Rows */}
            {section.metrics.map((metric, idx) => (
              <View key={idx} style={styles.tableRow}>
                <Text style={styles.tableCell}>{metric.label}</Text>
                <Text style={styles.tableCell}>{metric.value}</Text>
              </View>
            ))}
          </View>

          {/* Chart Image */}
          {chartImages && chartImages[section.title] && (
            <Image src={chartImages[section.title]} style={styles.chartImage} />
          )}

          {/* Footer */}
          <Text
            style={styles.footer}
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages} — Generated by Vaisnava Marriage`
            }
            fixed
          />
        </Page>
      ))}
    </Document>
  );
};

export default PDFReport;
